import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { toast } from 'react-toastify';
import Box from '@mui/material/Box';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
// import { store } from '../../../../index';
// import { setMachineStandStillInfo } from '../../../../Reducers/machineStandStill/machineStandStillActions';

import { connect } from 'react-redux';
import { StandStillTypes } from '../../../../Config/constants';

export const StandstillCleaningReasonDrawer = (props) => {

    const classes = useStyles();
    const { t } = useTranslation();
    const [checked, setChecked] = useState(false);
    const [nieuwefilter, setNieuwefilter] = useState(false);
    const [reservefilter, setReservefilter] = useState(false);
    const [kuisenfilter, setKuisenfilter] = useState(false);
    const [gaatjes, setGaatjes] = useState(false);
    const [reinigen, setReinigen] = useState(false);
    const [gaatjesVrijmaken, setGaatjesVrijmaken] = useState(false);
    const [mondstuk, setMondstuk] = useState(false);
    const [beentjes, setBeentjes] = useState(false);
    const [gaatesUitstekken, setGaatesUitstekken] = useState(false);
    const [lippen, setLippen] = useState(false);
    const [elektroden, setElektroden] = useState(false);
    const [mesjes, setMesjes] = useState(false);
    const [uitvoerrollen, setUitvoerrollen] = useState(false);
    const [restenUithalen, setRestenUithalen] = useState(false);
    const [opkuisMachine, setOpkuisMachine] = useState(false);
    const [reinigenSchema, setReinigenSchema] = useState(false);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [remark, setRemark] = useState('');
    const [validate, setValidate] = useState(false);
    const drawerRef = useRef(null);
    // const [drawerWidth, setDrawerWidth] = useState(0);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        // if (drawerRef.current) {
        //     const width = drawerRef.current.clientWidth;
        //     setDrawerWidth(width);
        // }
        // find if current machine has machineStandStillInfo in redux (redux has array of all machines with machineStandStillInfo)
        if (!loaded) {
            let currentCleaningProgress = checkForRunningCleaning();

            if (currentCleaningProgress) {
                setChecked(currentCleaningProgress.progress.checked);
                setNieuwefilter(currentCleaningProgress.progress.nieuwefilter);
                setReservefilter(currentCleaningProgress.progress.reservefilter);
                setKuisenfilter(currentCleaningProgress.progress.kuisenfilter);
                setGaatjes(currentCleaningProgress.progress.gaatjes);
                setReinigen(currentCleaningProgress.progress.reinigen);
                setGaatjesVrijmaken(currentCleaningProgress.progress.gaatjesVrijmaken);
                setMondstuk(currentCleaningProgress.progress.mondstuk);
                setBeentjes(currentCleaningProgress.progress.beentjes);
                setGaatesUitstekken(currentCleaningProgress.progress.gaatesUitstekken);
                setLippen(currentCleaningProgress.progress.lippen);
                setElektroden(currentCleaningProgress.progress.elektroden);
                setMesjes(currentCleaningProgress.progress.mesjes);
                setUitvoerrollen(currentCleaningProgress.progress.uitvoerrollen);
                setRestenUithalen(currentCleaningProgress.progress.restenUithalen);
                setOpkuisMachine(currentCleaningProgress.progress.opkuisMachine);
                setReinigenSchema(currentCleaningProgress.progress.reinigenSchema);
                setRemark(currentCleaningProgress.progress.remark);
            } else {
                addNewStandStill();
            }
            setLoaded(true);
        }

    }, []);

    const checkForRunningCleaning = () => {
        let tempAllMachineStandStills = props.machineStandStill.machineStandStillInfo;
        if (tempAllMachineStandStills.length > 0) {
            let tempMachineStandStill = tempAllMachineStandStills.find(x => x.machineId === props.machineId);
            if (tempMachineStandStill) {
                return tempMachineStandStill;
            }
        }
        return null;
    }

    const addNewStandStill = () => {
        let newStandStill = {
            machineId: props.machineId,
            standStillType: StandStillTypes.CLEANSTART,
            progress: {
                checked: false,
                nieuwefilter: false,
                reservefilter: false,
                kuisenfilter: false,
                gaatjes: false,
                reinigen: false,
                gaatjesVrijmaken: false,
                mondstuk: false,
                beentjes: false,
                gaatesUitstekken: false,
                lippen: false,
                elektroden: false,
                mesjes: false,
                uitvoerrollen: false,
                restenUithalen: false,
                opkuisMachine: false,
                reinigenSchema: false,
                remark: ""
            }
        }
        console.log('props.machineStandStill.machineStandStillInfo) ', props.machineStandStill.machineStandStillInfo);
        let currentStandStills = JSON.parse(JSON.stringify(props.machineStandStill.machineStandStillInfo));
        console.log('newStandStill ', newStandStill)
        currentStandStills.push(newStandStill)
        //props.setMachineStandStillInfo(currentStandStills);
    }

    const handleDrawerClose = () => {
        let tempCleaningProgress = {
            machineId: props.machineId,
            standStillType: StandStillTypes.CLEANSTART,
            progress: {
                checked: checked,
                nieuwefilter: nieuwefilter,
                reservefilter: reservefilter,
                kuisenfilter: kuisenfilter,
                gaatjes: gaatjes,
                reinigen: reinigen,
                gaatjesVrijmaken: gaatjesVrijmaken,
                mondstuk: mondstuk,
                beentjes: beentjes,
                gaatesUitstekken: gaatesUitstekken,
                lippen: lippen,
                elektroden: elektroden,
                mesjes: mesjes,
                uitvoerrollen: uitvoerrollen,
                restenUithalen: restenUithalen,
                opkuisMachine: opkuisMachine,
                reinigenSchema: reinigenSchema,
                remark: remark
            }
        }
        let tempAllMachineStandStills = [];
        if (props.machineStandStill.machineStandStillInfo !== null && props.machineStandStill.machineStandStillInfo !== undefined && props.machineStandStill.machineStandStillInfo.length > 0) {
            tempAllMachineStandStills = [...props.machineStandStill.machineStandStillInfo];
            const existingMachineStandStill = tempAllMachineStandStills.find(x => x.machineId === props.machineId);

            if (existingMachineStandStill) {
                const index = tempAllMachineStandStills.indexOf(existingMachineStandStill);
                tempAllMachineStandStills[index] = tempCleaningProgress;
            } else {
                tempAllMachineStandStills.push(tempCleaningProgress);
            }
        } else {
            tempAllMachineStandStills.push(tempCleaningProgress);
        }

        console.log('Updated StandStills:', tempAllMachineStandStills);

        props.actions.setMachineStandStillInfo(tempAllMachineStandStills);
        props.setStandstillCleaningReasonPopupOpen(false);
    }

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    const handleChangeNieuweFilter = (event) => {
        setNieuwefilter(event.target.checked);
    };

    const handleChangeReserveFilter = (event) => {
        setReservefilter(event.target.checked);
    };

    const handleChangeKuisenFilter = (event) => {
        setKuisenfilter(event.target.checked);
    };

    const handleChangeGaatjes = (event) => {
        setGaatjes(event.target.checked);
    };

    const handleChangeReinigen = (event) => {
        setReinigen(event.target.checked);
    };

    const handleChangeGaatjesVrijmaken = (event) => {
        setGaatjesVrijmaken(event.target.checked);
    };

    const handleChangeMondstuk = (event) => {
        setMondstuk(event.target.checked);
    };

    const handleChangeBeentjes = (event) => {
        setBeentjes(event.target.checked);
    };

    const handleChangeGaatjesUitstekken = (event) => {
        setGaatesUitstekken(event.target.checked);
    };

    const handleChangeLippen = (event) => {
        setLippen(event.target.checked);
    };

    const handleChangeElektroden = (event) => {
        setElektroden(event.target.checked);
    };

    const handleChangeMesjes = (event) => {
        setMesjes(event.target.checked);
    };

    const handleChangeUitvoerRollen = (event) => {
        setUitvoerrollen(event.target.checked);
    };

    const handleChangeRestenUithalen = (event) => {
        setRestenUithalen(event.target.checked);
    };

    const handleChangeOpkuisenMachine = (event) => {
        setOpkuisMachine(event.target.checked);
    };

    const handleChangeReinigenSchema = (event) => {
        setReinigenSchema(event.target.checked);
    };

    const handleChangeUser = (event) => {
        setUserName(event.target.value);
    };

    const handleChangePassword = (event) => {
        setPassword(event.target.value);
    };

    const handleChangeRemark = (event) => {
        setRemark(event.target.value);
    };

    const validateAndSave = () => {
        if (!(nieuwefilter && reservefilter && kuisenfilter && gaatjes & reinigen && gaatjesVrijmaken && mondstuk && beentjes && gaatesUitstekken && lippen && mesjes && uitvoerrollen && restenUithalen && opkuisMachine && reinigenSchema)) {
            setValidate(true);
            toast.error(t("Check alle nodige stappen af"), { position: "top-center" });
        } else {
            props.action(checked, userName, password, nieuwefilter, reservefilter, kuisenfilter, gaatjes, reinigen, gaatjesVrijmaken, mondstuk, beentjes, gaatesUitstekken, lippen, elektroden, mesjes, uitvoerrollen, restenUithalen, opkuisMachine, reinigenSchema, remark)
        }
    }

    return (
        <Drawer variant="temporary" className={classes.drawer} ref={drawerRef} anchor='right'
            open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => handleDrawerClose()} transitionDuration={500}>
            <div className={classes.drawerBody}>
                <div className={classes.header}>
                    <div className={classes.title}>{t("Reinigen")}</div>
                    <div className={classes.close}>
                        <Button className={classes.closeButton} onClick={() => handleDrawerClose()}>
                            <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                        </Button>
                    </div>
                </div>
                <Box sx={{ position: 'relative', width: "100%" }}>
                    <Box sx={{ position: 'relative' }}>
                        {/* Step 1 */}
                        <Box>
                            <TableContainer component={Paper}>
                                <Table stickyHeader aria-label="sticky table" id="standStillCleaningReasonDrawerTable">
                                    <TableHead className={classes.tableHeader}>
                                        <TableRow className={classes.tableHeaderRow}>
                                            <TableCell className={classes.tableHeaderCell} ></TableCell>
                                            <TableCell className={classes.tableHeaderCell} align="right">{t("TAAK")}</TableCell>
                                            <TableCell className={classes.tableHeaderCell} align="right">{t("WIE?")}</TableCell>
                                            <TableCell className={classes.tableHeaderCell} align="center">{t("CHECK")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell className={classes.unevenHeaderCellStyleTitle}>{t("1. Filter")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Nieuwe filter")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Extrudeur")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !nieuwefilter })} checked={nieuwefilter} onChange={handleChangeNieuweFilter} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell align="right">{t("Filter uithalen + reserve plaatsen")}</TableCell>
                                            <TableCell align="right">{t("Extrudeur + Verpakker")}</TableCell>
                                            <TableCell align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !reservefilter })} checked={reservefilter} onChange={handleChangeReserveFilter} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell align="right">{t("Kuisen filterblok")}</TableCell>
                                            <TableCell align="right">{t("Extrudeur")}</TableCell>
                                            <TableCell align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !kuisenfilter })} checked={kuisenfilter} onChange={handleChangeKuisenFilter} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow className={classes.evenHeaderRowStyle}>
                                            <TableCell className={classes.evenHeaderCellStyleTitle}>{t("2. Kalibers")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="right">{t("Gaatjes + gleuven vrijmaken")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="right">{t("Extrudeur")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !gaatjes })} checked={gaatjes} onChange={handleChangeGaatjes} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow className={classes.evenRowStyle}>
                                            <TableCell></TableCell>
                                            <TableCell align="right">{t("Oppervlakte reinigen")}</TableCell>
                                            <TableCell align="right">{t("Extrudeur")}</TableCell>
                                            <TableCell align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !reinigen })} checked={reinigen} onChange={handleChangeReinigen} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.unevenHeaderCellStyleTitle}>{t("3. Airblower")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Gaatjes vrijmaken")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Extrudeur")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !gaatjesVrijmaken })} checked={gaatjesVrijmaken} onChange={handleChangeGaatjesVrijmaken} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow className={classes.evenHeaderRowStyle}>
                                            <TableCell className={classes.evenHeaderCellStyleTitle}>{t("4. Matrijs")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="right">{t("Mondstuk reinigen")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="right">{t("Extrudeur")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !mondstuk })} checked={mondstuk} onChange={handleChangeMondstuk} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow className={classes.evenRowStyle}>
                                            <TableCell></TableCell>
                                            <TableCell align="right">{t("Beentjes uitstekken")}</TableCell>
                                            <TableCell align="right">{t("Extrudeur")}</TableCell>
                                            <TableCell align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !beentjes })} checked={beentjes} onChange={handleChangeBeentjes} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow className={classes.evenRowStyle}>
                                            <TableCell></TableCell>
                                            <TableCell align="right">{t("Gaatjes uitstekken")}</TableCell>
                                            <TableCell align="right">{t("Extrudeur")}</TableCell>
                                            <TableCell align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !gaatesUitstekken })} checked={gaatesUitstekken} onChange={handleChangeGaatjesUitstekken} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow className={classes.evenRowStyle}>
                                            <TableCell></TableCell>
                                            <TableCell align="right">{t("Lippen uitstekken")}</TableCell>
                                            <TableCell align="right">{t("Extrudeur")}</TableCell>
                                            <TableCell align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !lippen })} checked={lippen} onChange={handleChangeLippen} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.unevenHeaderCellStyleTitle}>{t("5. Coronatoestel")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Elektroden reinigen")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Extrudeur + Verpakker")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="center"><Checkbox checked={elektroden} onChange={handleChangeElektroden} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow className={classes.evenHeaderRowStyle}>
                                            <TableCell className={classes.evenHeaderCellStyleTitle}>{t("6. Mesjes")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="right">{t("Monteren nieuwe mesjes")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="right">{t("Verpakker")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !mesjes })} checked={mesjes} onChange={handleChangeMesjes} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.unevenHeaderCellStyleTitle}>{t("7. Guillotine")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Reinigen invoerrollen")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Verpakker")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !uitvoerrollen })} checked={uitvoerrollen} onChange={handleChangeUitvoerRollen} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell align="right">{t("Resten uithalen")}</TableCell>
                                            <TableCell align="right">{t("Verpakker")}</TableCell>
                                            <TableCell align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !restenUithalen })} checked={restenUithalen} onChange={handleChangeRestenUithalen} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow className={classes.evenHeaderRowStyle}>
                                            <TableCell className={classes.evenHeaderCellStyleTitle}>{t("8. Algemeen")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="right">{t("Opkuis rond machine")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="right">{t("Verpakker")}</TableCell>
                                            <TableCell className={classes.evenHeaderCellStyle} align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !opkuisMachine })} checked={opkuisMachine} onChange={handleChangeOpkuisenMachine} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.unevenHeaderCellStyleTitle}>{t("9. Reinigen")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Machineonderdeel reinigen volgens schema")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="right">{t("Extrudeur + Verpakker")}</TableCell>
                                            <TableCell className={classes.unevenHeaderCellStyle} align="center"><Checkbox className={clsx({ [classes.errorCheck]: validate && !reinigenSchema })} checked={reinigenSchema} onChange={handleChangeReinigenSchema} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className={classes.remarkField}>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    label={t("Remark")}
                                    multiline
                                    maxRows={4}
                                    value={remark}
                                    onChange={handleChangeRemark}
                                    fullWidth
                                />
                            </div>

                        </Box>


                        <div className={classes.supervisorLabels}>
                            <div>{t("Ben je zeker dat alles correct werd ingevuld en dat de kuisprocedure volledig werd beëindigd")}?</div>
                            <div>{t("Vraag je ploegchef om de kuisprocedure te kunnen beëindigen.")}</div>
                        </div>

                        <div className={classes.remarkField}>
                            <FormGroup>
                                <TextField sx={{ marginTop: '15px' }} key="supervisor-user" id="supervisor-user" disabled={checked} label={t("UsernameSuperVisor")} value={checked ? "" : userName} variant="outlined" onChange={handleChangeUser} />
                                <TextField sx={{ marginTop: '20px' }} key="supervisor-pass" id="standard-basic" disabled={checked} label={t("PasswordSuperVisor")} value={checked ? "" : password} type="password" variant="outlined" onChange={handleChangePassword} />
                                <FormControlLabel control={<Checkbox
                                    checked={checked}
                                    onChange={handleChange}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />} label={t("Ploegchef niet aanwezig")} />
                            </FormGroup>
                        </div>

                    </Box>

                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingBottom: '20px' }}>
                    <Button className={classes.greenButton} disabled={(!checked && (userName === "" || password === ""))} onClick={() => validateAndSave()}>
                        {t("SAVE")}
                    </Button>
                </Box>

            </div>
        </Drawer >
    )
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "700px",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "5px",
        paddingTop: "10px",
        position: 'relative',
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "auto",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        float: 'left',
    },
    title: {
        float: 'left',
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px"
    },
    header: {
        width: "100%",
        height: "5%",
    },
    greenButton: {
        maxWidth: "300px",
        backgroundColor: FlagstoneTheme.palette.lightGreen.main,
        color: "white",
        paddingLeft: '25px',
        paddingRight: '25px',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        borderRadius: "6px",
        "&:hover": {
            background: FlagstoneTheme.palette.lightGreen.main
        },
    },

    upperLeftContainer: {
        float: "left",
        width: "50%",
        boxSizing: "border-box",
        borderRight: "1px solid #DEDEDE",
        height: "500px",
    },

    upperRightContainer: {
        float: "left",
        width: "50%",
        boxSizing: "border-box",
        height: "500px",
        paddingLeft: "20px"
    },
    lowerContainer: {
        borderTop: "1px solid #DEDEDE",
        width: "100%",
        paddingTop: "20px",
        height: "330px"
    },
    buttonContainer: {
        height: "50px",
        textAlign: "center",
        backgroundColor: "white",
        position: "fixed",
        bottom: "0",
        right: "0",
        boxShadow: "0px 3px 25px #00000029",
        paddingTop: "10px"
    },
    remarkField: {
        marginTop: "15px"
    },
    spacer: {
        height: "75px"
    },
    supervisorLabels: {
        marginTop: "15px",
        display: "grid !important"
    },
    errorCheck: {
        color: "red !important"
    },

    evenHeaderRowStyle: {
        backgroundColor: '#ddedf0', // Custom background color
    },
    evenHeaderCellStyle: {
        borderTop: '2px solid #7ba4ab',
        backgroundColor: '#ddedf0', // Custom background color
    },
    unevenHeaderCellStyle: {
        borderTop: '2px solid #7ba4ab',
    },
    unevenHeaderCellStyleTitle: {
        borderTop: '2px solid #7ba4ab',
        fontWeight: '600 !important'
    },
    evenHeaderCellStyleTitle: {
        borderTop: '2px solid #7ba4ab',
        backgroundColor: '#ddedf0', // Custom background color
        fontWeight: '600!important'
    },
    evenRowStyle: {
        backgroundColor: '#ddedf0', // Custom background color
    },
    tableHeaderCell: {
        backgroundColor: '#7ba4ab !important',
        color: 'white !important',
        fontWeight: '650 !important'
    }
}));

function mapStateToProps(state) {
    return {
        machineStandStill: state.machineStandStill
    }
}

export default connect(mapStateToProps)(StandstillCleaningReasonDrawer)
